import React from "react";
import moon from "../../assets/alltarotcards/moon.jpg";
import CommonNavbar from "../CommonNavbar";
import { Link, useNavigate } from "react-router";
import { FaChevronRight, FaHome } from "react-icons/fa";
import Footer from "../../home/Footer";
import Queryform from "../Queryform";
import Navbar from "../../home/Navbar";
const MoonLove = () => {
    const navigate = useNavigate();
    const buttonClick = () => {
        navigate('/love/tarot');
    }
    return (
        <>
            <section className='bg-gradient-to-r from-white to-success/40 text-gray-900 min-h-screen'>
                <div>
                    <Navbar />
                </div>
                <div className='text-gray-900 flex flex-col items-center mt-12'>
                    <h1 className='text-3xl font-serif text-secondary font-bold mb-2'>LOVE TAROT</h1>
                </div>
                <div className="w-full max-w-3xl text-sm text-gray-600 flex flex-wrap justify-center sm:justify-start items-center mt-6 px-4 sm:px-8">
                    <Link to="/" className="text-secondary hover:underline">
                        HOME
                    </Link>
                    <FaChevronRight className="mx-2 text-gray-500" />

                    <Link to="/tarot" className="text-secondary hover:underline">
                        Tarot
                    </Link>
                    <FaChevronRight className="mx-2 text-gray-500" />
                    <Link to="/love/tarot" className="text-secondary hover:underline">
                        Love Tarot
                    </Link>
                    <FaChevronRight className="mx-2 text-gray-500" />
                    <span className="text-gray-700 font-semibold">MOON</span>
                </div>
                <main className="flex items-center mt-10 justify-center text-center">
                    <div className="max-w-5xl w-full flex flex-col items-center justify-center text-center lg:flex-row gap-8">
                        {/* Card Section */}
                        <div className="flex flex-col shadow-md items-center lg:items-start">
                            <div className=" rounded-lg p-6 bg-transparent flex flex-col justify-center items-center w-80">
                                <div className="">
                                    {/* Tarot Card Image */}
                                    <img
                                        src={moon}
                                        alt="The World Tarot Card"
                                        className="w-full h-auto object-cover"
                                    />
                                    {/* Title at the bottom of the card */}
                                    <div className="  text-center text-primary font-bold text-lg">
                                        THE MOON
                                    </div>
                                </div>
                            </div>
                        </div>

                        {/* Description Section */}
                        <div className="flex-1">
                            <h2 className="text-2xl font-bold mb-4">The MOON</h2>
                            <p className="text-gray-600 max-w-2xl mb-6 text-justify leading-relaxed">
                                Having too many choices can leave you feeling confused, and that confusion can breed dissatisfaction. The Moon card urges you to pay attention to your subconscious, as it may already hold the answers you’re seeking in your romantic situation. Often, the clarity you’re looking for is already inside you, waiting to be uncovered. Tap into your creativity to break free from the logical constraints you've set, allowing yourself to see things from a fresh, more intuitive perspective that could lead to greater understanding.
                            </p>
                            <div className="mb-6">
                                <p className="text-sm text-gray-500">
                                    Learn more about Tarot
                                    <a href="/learn" className="text-blue-500 ml-1 underline">
                                        Click here.
                                    </a>
                                </p>
                            </div>
                            {/* Button */}
                            <button onClick={buttonClick} className="bg-gray-900 text-white py-2 px-20 rounded-lg font-semibold shadow-md hover:bg-secondary transition duration-300">
                                Pick Another Card
                            </button>
                        </div>
                    </div>
                </main>
                <Queryform />
                <Footer />
            </section>
        </>
    )
}

export default MoonLove